import { render, staticRenderFns } from "./RequalifyCandidateButton.vue?vue&type=template&id=156986ba&"
import script from "./RequalifyCandidateButton.vue?vue&type=script&lang=js&"
export * from "./RequalifyCandidateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports